import Modal from 'react-bootstrap/Modal';

import { ButtonPrimary, ModalClose } from '../../common/components';
import { FAQManagementModalWrapper } from './FAQManagementStyles.js';
import { useEffect, useState } from 'react';
import { FAQAccordionItem } from './FAQAccordionItem';
import { toast } from 'react-toastify';
import { useMsal } from '@azure/msal-react';
import { getFAQDocumentImageUrlAdmin } from '../../common/api/adminFaqApi';

type FAQPreviewModalProps = {
  show: boolean;
  item: Api.IFAQItem;
  onClose: () => void;
};

const defaultProps = {
  show: true,
  item: {},
};

export const FAQPreviewModal = (props: FAQPreviewModalProps) => {
  const { show, item } = props;
  const { instance, accounts } = useMsal();

  const [openItemId, setOpenItemId] = useState<string | null>(item?.faqId);
  const [containsImage, setContainsImage] = useState<boolean>(false);
  const [imageSrc, setImageSrc] = useState<any>(undefined);

  const toggleItem = (id: string): void => {
    setOpenItemId(prev => (prev === id ? null : id));
  };

  useEffect(() => {
    setOpenItemId(item?.faqId);
    setImageSrc(undefined);
    setContainsImage(false);

    // Open accordion for Preview
    toggleItem(item?.id);
  }, [item]);

  const error = (error: string) => {
    const message = `API error calling: ${error}`;
    console.error(message);
    toast.error(message, { position: 'bottom-right' });
  };

  const imageSuccess = (blob: any) => {
    const objectUrl = URL.createObjectURL(blob);
    setImageSrc(objectUrl);
  };

  useEffect(() => {
    if (isOpen && item && item.faqDocumentId) {
      setContainsImage(true);
      getFAQDocumentImageUrlAdmin(accounts[0], instance, item.faqDocumentId, imageSuccess, error);
    }
  }, [openItemId]);

  const isOpen = openItemId === item?.id;

  return (
    <>
      <Modal animation={false} className={'custom-modal'} show={show} size={'xl'} backdrop='static' centered>
        <FAQManagementModalWrapper>
          <Modal.Header>
            <Modal.Title>Preview FAQ</Modal.Title>
            <ModalClose onClick={props.onClose} />
          </Modal.Header>

          <Modal.Body>
            <div className='accordion' id='myAccordion'>
              <FAQAccordionItem
                item={item}
                containsImage={containsImage}
                imageSrc={imageSrc}
                isOpen={isOpen}
                toggleItem={() => {}}
              ></FAQAccordionItem>
            </div>
          </Modal.Body>
          <div className='pt-4 float-right'>
            <ButtonPrimary
              onClick={event => {
                event.preventDefault();
                props.onClose();
              }}
              className='ml-4 upload-btn'
              title='OK'
            ></ButtonPrimary>
          </div>
        </FAQManagementModalWrapper>
      </Modal>
    </>
  );
};

FAQPreviewModal.defaultProps = defaultProps;
